import {
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  NumberInput,
  required,
} from 'react-admin';

export const CaseCategoryEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput
        source="name"
        validate={[required()]}
        fullWidth
      />
      <TextInput
        source="slug"
        fullWidth
        helperText="Будет сгенерирован автоматически, если не указан"
      />
      <BooleanInput
        source="isActive"
      />
      <NumberInput
        source="sortOrder"
        min={0}
      />
    </SimpleForm>
  </Edit>
);
